import * as z from 'zod';

import { inventoryCategoryQueryLinkerSchema } from '@/_pages/settings/inventory-categories/shared/schemas/inventory-category-query-linker-schema';

import { inventoryKitQuerySchema } from './inventory-kits-query-schema';

import { inventoryKitItemFormSchema } from '../inventory-kit-item/inventory-kit-item-form-schema';

export const inventoryKitFormSchema = inventoryKitQuerySchema
  .omit({
    inventory_kit_items: true,
    category_id: true,
    category: true,
  })
  .extend({
    inventory_kit_items: z.array(inventoryKitItemFormSchema),
    category: inventoryCategoryQueryLinkerSchema.refine((v) => v.id !== -1, {
      message: 'Category is required',
    }),
  });

export type InventoryKitFormSchema = z.infer<typeof inventoryKitFormSchema>;
